import { Injectable } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { GoAPI, INodeStructure, JSONAPIResponse } from '../connector';
import { OneTimeTokenAction } from './onetimetoken.actions';
import { Action } from '../shared/common.action';
import { Observable } from 'rxjs/Observable';
import { CommonEffects } from '../shared';

@Injectable()
export class OneTimeTokenEffects {

  @Effect() fetchByToken$ = this.actions$
    .pipe(ofType(OneTimeTokenAction.LOAD_BY_TOKEN))
    .mergeMap((action: Action) => this.api.byToken(action.token).findAllWithToken(action.token)
      .mergeMap((response: JSONAPIResponse<INodeStructure[]>) => {
        return this.commonEffects.getObservables(this.oneTimeTokenAction.loadSuccess, ['nodestructures', 'nodedata', 'relationships', 'humanresources'], response);
      })
    ).catch((error: any) => Observable.of(this.oneTimeTokenAction.loadFail(error)));

  @Effect() updateByToken$ = this.actions$
    .pipe(ofType(OneTimeTokenAction.UPDATE_BY_TOKEN))
    .mergeMap((action: Action) => this.api.byToken(action.token).updateByToken(action.token, action.payload)
      .mergeMap((response: JSONAPIResponse<INodeStructure[]>) => Observable.from([
        this.oneTimeTokenAction.updateByTokenSuccess(response.included)
      ]))
    ).catch((error: any) => Observable.of(this.oneTimeTokenAction.updateByTokenFail(error)));

  @Effect() transferByToken$ = this.actions$
    .pipe(ofType(OneTimeTokenAction.TRANSFER_BY_TOKEN))
    .mergeMap((action: Action) => this.api.transferByToken(action.token).updateByToken(action.token, action.payload)
      .mergeMap((response: JSONAPIResponse<any[]>) => {
        return this.commonEffects.getObservables(this.oneTimeTokenAction.transferByTokenSuccess, ['nodestructures', 'nodedata', 'relationships', 'humanresources'], response);
      })
    ).catch((error: any) => Observable.of(this.oneTimeTokenAction.transferByTokenFail(error)));

  @Effect() loadApp$ = this.actions$
    .pipe(ofType(OneTimeTokenAction.LOAD_APP))
    .mergeMap((action: Action) => this.api.loadApp().post(action.payload, undefined, undefined, 'app')
      .mergeMap((response: JSONAPIResponse<any>) => Observable.from([
        this.oneTimeTokenAction.loadAppSuccess(action.payload, response)
      ]))
    ).catch((error: any) => Observable.of(this.oneTimeTokenAction.loadAppFail(error)));

  constructor(private api: GoAPI,
              private actions$: Actions,
              private commonEffects: CommonEffects,
              private oneTimeTokenAction: OneTimeTokenAction) {}
}
